import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import Color from '../Color.js';
export default (function () {
  try {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _construct(Color, args);
    return true;
    // eslint-disable-next-line
  } catch (e) {
    return false;
  }
});